import { makeStyles } from 'tss-react/mui'
import { Unstable_Grid2 as Grid } from '@mui/material'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { useAvailabilityMessageTracking } from '../TrackedAvailabilityMessage/TrackedAvailabilityMessage'
import { Availability } from '../TrackedAvailabilityMessage/utils'

type PromosProps = {
  promoCode: string
  promoDiscount: number
  availability?: Availability
  gaMessageId?: string
}

const useStyles = makeStyles()((theme) => ({
  promoContainer: {
    background: theme.palette.promoGreen,
    padding: theme.spacing(2, 3),
  },
  bold: {
    fontWeight: 600,
  },
  promoDiscountMessage: {
    fontSize: theme.typography.pxToRem(14),
  },
  webOnlyDiscountMessage: {
    fontStyle: 'italic',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightRegular,
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
}))

const Promos = ({
  availability,
  gaMessageId,
  promoCode,
  promoDiscount,
}: PromosProps) => {
  const { classes } = useStyles()
  useAvailabilityMessageTracking(gaMessageId, availability)

  return (
    <Grid
      className={classes.promoContainer}
      container
      data-testid="promos-container"
    >
      <Grid>
        <span className={classes.promoDiscountMessage}>
          <span className={classes.bold}>
            <FormattedMessage id="SAVE" defaultMessage="Save" />
          </span>{' '}
          <FormattedMessage
            id="DISCO_PROMO_MESSAGE"
            defaultMessage="{promoDiscount} with code {promoCode}"
            values={{
              promoDiscount: (
                <span className={classes.bold}>
                  <FormattedNumber
                    value={promoDiscount / 100}
                    style="percent"
                    minimumFractionDigits={0}
                  />
                </span>
              ),
              promoCode: <span className={classes.bold}>{promoCode}</span>,
            }}
          />
        </span>
      </Grid>
      <Grid className={classes.webOnlyDiscountMessage}>
        <FormattedMessage
          id="WEB_ONLY_DISCOUNT"
          defaultMessage="Web-Only Discount"
        />
      </Grid>
    </Grid>
  )
}

export default Promos
